module.exports = __webpack_public_path__ + "img/yinboguojipijiubowuguan.a909c208.png";